type ServiceCategory = {
    name: string,
    id: number
}
export function getServiceCategory( categoryId:number ) {
    const categories = JSON.parse(localStorage.getItem("serviceCategories") || "");
    if(categories.filter((x:ServiceCategory) => x.id === categoryId).length > 0){
        return categories.filter((x:ServiceCategory) => x.id === categoryId)[0].name;
    } else {
        return 'CATEGORIA NON PRESENTE';
    }
    
};


export function getServiceImageByCategory( categoryId:number ) {
    switch (categoryId) {
        case 1:
          return 'SEZIONE-SERVIZI_BANNER_Alimentazione_1-1.svg';
        case 2:
          return 'SEZIONE-SERVIZI_BANNER_Dermocosmesi_1-1.svg';
        case 3:
          return 'SEZIONE-SERVIZI_BANNER_Mamma-Bambino_1-1.svg';
        case 4:
          return 'SEZIONE-SERVIZI_BANNER_Petcare_1-1.svg';
        case 5:
          return 'SEZIONE-SERVIZI_BANNER_Prevenzione_1-1.svg';
        case 6:
          return 'SEZIONE-SERVIZI_BANNER_Persona_1-1.svg';
        default:
          return '';
    }
};